import { cn } from '@invent/wl-ui-kit-next';
import { Label } from '@invent/wl-ui-kit-next/ui';

import { LinkedText } from './linked-text';

/**
 * A question's words and its required mark — on a field, a table, a percent group's legend and a
 * repeat's head alike (the survey review's G17, the plan's D12).
 *
 * The mark is one `*` right after the last word, inline, so a label that wraps carries it at the
 * end of its last line; "(required)" says it to a screen reader, the `*` being hidden from one. The
 * kit's `SimpleFormField` set the mark as a flex item of its `Label`, which pushed it to the far
 * right of a wrapped label, and took only a string; it is not used here. An `https://` address in
 * the words is a link (`LinkedText`).
 */
export function QuestionLabel({
  as = 'label',
  text,
  required,
  htmlFor,
  id,
  className
}: {
  /** The element the words sit in: a field's `label`, a fieldset's `legend`, a repeat's `h4`. */
  as?: 'label' | 'legend' | 'h4';
  text: string;
  required: boolean;
  htmlFor?: string;
  /** For a control the `label` cannot name alone — a month-day's two lists name themselves by it. */
  id?: string;
  className?: string;
}) {
  const words = (
    <>
      <LinkedText text={text} />
      {required && (
        <>
          <span aria-hidden className="ml-0.5 text-destructive">
            *
          </span>
          <span className="sr-only"> (required)</span>
        </>
      )}
    </>
  );
  if (as === 'label') {
    return (
      <Label id={id} htmlFor={htmlFor} className={cn('!mb-0 block leading-snug', className)}>
        {words}
      </Label>
    );
  }
  const Element = as;
  return (
    <Element id={id} className={className}>
      {words}
    </Element>
  );
}
